import React from 'react';
import PropTypes from 'prop-types';
import Fade from '@mui/material/Fade';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import styled from 'styled-components';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))`
  & .${tooltipClasses.tooltip} {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    max-width: none;
  }
`;

// this element is needed for tooltip to work properly in case that provided children can't hold ref
const StyledAnchor = styled.div`
  display: inline-block;
`;

const HtmlTooltip = ({ children, renderHtml, popperProps = {} }) => {
  return (
    <StyledTooltip
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 100 }}
      disableInteractive
      placement="bottom-start"
      title={renderHtml}
      PopperProps={popperProps}
    >
      <StyledAnchor>{children}</StyledAnchor>
    </StyledTooltip>
  );
};

HtmlTooltip.propTypes = {
  renderHtml: PropTypes.node.isRequired,
};

export default HtmlTooltip;
